import deepmerge from "deepmerge";
import { DEFAULT_THEME } from "../presets/default";
export var createTheme = function (name, config) {
  if (config === void 0) {
    config = {};
  }
  var light = config.light || {};
  var dark = config.dark || {};
  // merge the light color as a base and augment with dark
  var modeDependent = {
    light: light,
    dark: dark
  };
  var base = deepmerge(DEFAULT_THEME, config);
  var merged = deepmerge(base, modeDependent);
  // ---- Apply Back-Compat Patches ---->
  // assert that color is available here, as we know it is in the DEFAULT_THEME
  // merged.light.color!.appChrome = merged.light.color?.brightWarm;
  // merged.dark.color!.appChrome = merged.dark.color?.brightWarm;
  return merged;
};